(function () {
	async function handleAbTestGroup() {
		const abTestGroup = "control";
		const cart = await fetch("/cart.json");
		const cartResponse = await cart.json();
		await updateCartAttributes({ cartResponse, abTestGroup });
		const style_to_remove = document.getElementById("kf-ab-test-style");
		if (style_to_remove) {
			style_to_remove.remove();
		}

		const default_style = document.getElementById("kf-ab-test-default-style");
		if (default_style) {
			default_style.remove();
		}

		const style_to_create = document.createElement("style");
		style_to_create.id = "kf-ab-test-style";
		style_to_create.textContent = `
      .hide-for-${abTestGroup} {
        display: none !important;
      }
    `;
		document.head.appendChild(style_to_create);
	}

	async function updateCartAttributes({ cartResponse, abTestGroup }) {
		const attributes = cartResponse.attributes;
		if (attributes["ab-test-group"] == abTestGroup) {
			return;
		}

		attributes["ab-test-group"] = abTestGroup;
		attributes["price-testing-v2"] = "true";
		await fetch("/cart/update.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ attributes }),
		});

		window.updatedCartAttributes = true;
		document.dispatchEvent(new Event("updatedCartAttributes"));
	}

	handleAbTestGroup();
	window.addEventListener("kuru_price_testing", handleAbTestGroup);
	document.addEventListener("DOMContentLoaded", handleAbTestGroup);
	window.addEventListener("load", handleAbTestGroup);
})();
